import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import { ClosePlanModel, PlanModel } from '../components/participants/plans/plan';
import { param } from 'jquery';

@Injectable({
  providedIn: 'root'
})
export class PlanService {
  apiUrl = environment.apiUrl

  httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient,private _authservice:AuthService) { }

  getPlanAndReminderSchedule():Observable<any>
  {
    const token = this._authservice.getAuthToken();
		const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    return this.http.get(this.apiUrl + 'participant/plans/getPlansAndRemindersSchedule', { headers: headers})
  }

  getPlanCheckListItems():Observable<any>
  {
    const token = this._authservice.getAuthToken();
		const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    return this.http.get(this.apiUrl + 'participant/plans/getPlanCheckListItems', { headers: headers})
    
  }

  getDaysOfWeek():Observable<any>
  {
    const token = this._authservice.getAuthToken();
		const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    return this.http.get(this.apiUrl + 'participant/plans/getDaysOfWeek', { headers: headers})
    
  }
  createPlan(plandetails: PlanModel): Observable<any> {
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    const { id, ...payload } = plandetails;
    const body = id ? plandetails : payload;
    return this.http.post(this.apiUrl + 'participant/plans/createPlan', body, { headers });
  }

  getParticipantPlans():Observable<any>
  {
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    return this.http.get(this.apiUrl + 'participant/plans/getParticipantPlans', { headers: headers})
  }

  getPlanDetailsForUpdate(planId: string): Observable<any> {
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    let params = new HttpParams();
    params = params.append('planId', planId);
    return this.http.get(this.apiUrl + 'participant/plans/getPlanDetailsForUpdate', { headers, params });
  }

  updatePlan(planDetails:PlanModel):Observable<any>
  {
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    return this.http.put(this.apiUrl + 'participant/plans/updatePlan',planDetails,{ headers:headers})
  }

  closePlan(closeplanmodel:ClosePlanModel):Observable<any>
  {
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    return this.http.post(this.apiUrl + 'participant/plans/closePlan',closeplanmodel,{ headers:headers})
  }

  viewPlan(planid: string): Observable<any> {
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    let params = new HttpParams();
    params = params.append('planId', planid);
    return this.http.get(this.apiUrl + 'participant/plans/getPlanView', { headers, params });
  }

  deletePlan(planId: string): Observable<any> {
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    let params = new HttpParams();
    params = params.append('planId', planId);
    return this.http.delete(this.apiUrl + 'participant/plans/deletePlan', { headers, params });
  }
}
